<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="触发器名称"><el-input v-model="queryParams.title" placeholder="请输入触发器名称"></el-input></el-form-item>
					<el-form-item label="设备名称"><el-input v-model="queryParams.deviceTitle" placeholder="请输入设备名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
						<el-button type="danger" size="small" @click="batchDelete" v-has="'btn_del'">批量删除</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column fixed type="selection" width="55"></el-table-column>
					<el-table-column prop="title" label="触发器名称"></el-table-column>
					<el-table-column prop="type" label="触发器类型">
						<template slot-scope="scope">
							{{scope.row.type | formatType}}
						</template>
					</el-table-column>
					<el-table-column prop="institutionName" label="所属组织" v-if="institutionId<=1"></el-table-column>
					<el-table-column prop="deviceTitle" label="触发主体"></el-table-column>
					<el-table-column prop="variableTitle" label="报警变量"></el-table-column>
					<el-table-column prop="triggerCondition" label="触发条件">
						<template slot-scope="scope">
							{{scope.row | formatTriggerCondition}}
						</template>
					</el-table-column>
					<el-table-column prop="triggerCondition" label="联动">
						<template slot-scope="scope">
							{{scope.row | formatLinkage}}
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="updateTime" label="更新时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看</el-button>
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="140px">
				<el-form-item label="触发器名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title"></el-input></el-form-item>
				<el-form-item label="触发器类型" prop="type">
					<el-select v-model="addOrUpdateForm.type" placeholder="请选择触发器类型">
						<el-option label="设备" value="device"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属机构" prop="institutionId" v-if="institutionId<=1">
					<el-select v-model="addOrUpdateForm.institutionId" filterable placeholder="请选择机构" @change="institutionChange">
						<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择设备和变量" prop="variableId">
					<el-select v-model="addOrUpdateForm.deviceId" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList" :loading="deviceLoading"
						@focus="deviceSelectFocus" :clearable="true" @change="deviceChange">
						<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="addOrUpdateForm.variableId" filterable remote reserve-keyword placeholder="请选择变量" :remote-method="queryTemplateVariableList"
						:loading="templateVariableLoading" @focus="templateVariableSelectFocus" :clearable="true" @change="templateVariableChange">
						<el-option v-for="item in templateVariableList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="触发条件" prop="triggerCondition">
					<el-select v-model="addOrUpdateForm.triggerCondition" placeholder="请选择触发条件">
						<el-option label="开关OFF" value="开关OFF"></el-option>
						<el-option label="开关ON" value="开关ON"></el-option>
						<el-option label="数值小于A" value="数值小于A"></el-option>
						<el-option label="数值大于B" value="数值大于B"></el-option>
						<el-option label="数值大于A且小于B" value="数值大于A且小于B"></el-option>
						<el-option label="数值小于A且大于B" value="数值小于A且大于B"></el-option>
						<el-option label="数值等于A" value="数值等于A"></el-option>
					</el-select>
					<el-input-number type="number" v-model="addOrUpdateForm.a" :controls="false" :min="1" :clearable="true"
						v-if="addOrUpdateForm.triggerCondition!=null&&addOrUpdateForm.triggerCondition.includes('A')" placeholder="请输入A值"></el-input-number>
					<el-input-number type="number" v-model="addOrUpdateForm.b" :controls="false" :min="1" :clearable="true"
						v-if="addOrUpdateForm.triggerCondition!=null&&addOrUpdateForm.triggerCondition.includes('B')" placeholder="请输入B值"></el-input-number>
				</el-form-item>
				<el-row>
					<el-col :span="10">
						<el-form-item label="报警" prop="openAlarm">
							<el-switch v-model="addOrUpdateForm.openAlarm">
							</el-switch>
						</el-form-item>
						<el-form-item label="报警内容" prop="alarmMessage" v-if="addOrUpdateForm.openAlarm">
							<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.alarmMessage"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="14">
						<el-form-item label="联动" prop="openLinkage">
							<el-switch v-model="addOrUpdateForm.openLinkage" @change="openLinkageChange">
							</el-switch>
						</el-form-item>
						<el-form-item label="联动类型" prop="linkageType" v-if="addOrUpdateForm.openLinkage">
							<el-select v-model="addOrUpdateForm.linkageType" placeholder="请选择联动类型" @change="linkageTypeChange">
								<el-option key="read" label="采集" value="read"></el-option>
								<el-option key="write" label="控制" value="write"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="联动变量" prop="linkageVariableId" v-if="addOrUpdateForm.openLinkage">
							<el-select v-model="addOrUpdateForm.linkageDeviceId" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryLinkageDeviceList"
								:loading="linkageDeviceLoading" @focus="linkageDeviceSelectFocus" :clearable="true" @change="linkageDeviceChange">
								<el-option v-for="item in linkageDeviceList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
							<el-select v-model="addOrUpdateForm.linkageVariableId" filterable remote reserve-keyword placeholder="请选择变量"
								:remote-method="queryLinkageTemplateVariableList" :loading="linkageTemplateVariableLoading" @focus="linkageTemplateVariableSelectFocus"
								:clearable="true" @change="linkageTemplateVariableChange">
								<el-option v-for="item in linkageTemplateVariableList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="" prop="linkageWriteType" v-if="addOrUpdateForm.openLinkage&&addOrUpdateForm.linkageType=='write'">
							<el-radio-group size="mini" v-model="addOrUpdateForm.linkageWriteType">
								<el-radio label="value">手写</el-radio>
								<el-radio label="trigger_value">触发值</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="" prop="linkageWriteValue"
							v-if="addOrUpdateForm.openLinkage&&addOrUpdateForm.linkageType=='write'&&addOrUpdateForm.linkageWriteType=='value'">
							<el-input-number type="number" v-model="addOrUpdateForm.linkageWriteValue" :controls="false" :min="1" :max="65536" :clearable="true"
								style="width: 300px;margin-top:-20px;display: block;" placeholder="请输入下发数据(十进制)"></el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>



		<!-- 详情 -->
		<el-dialog title="查看触发器" :visible.sync="dialogDetailVisible" width="600px" :close-on-click-modal="false">
			<el-row>
				<el-descriptions class="margin-top" :column="1" :labelStyle="label_style">
					<el-descriptions-item label="触发器名称">
						{{addOrUpdateForm.title}}
					</el-descriptions-item>
					<el-descriptions-item label="触发器类型">
						{{addOrUpdateForm.type | formatType}}
					</el-descriptions-item>
					<el-descriptions-item label="所属机构">
						{{addOrUpdateForm.institutionName}}
					</el-descriptions-item>
					<el-descriptions-item label="设备和变量">
						{{addOrUpdateForm.deviceTitle}}-{{addOrUpdateForm.variableTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="触发条件">
						{{addOrUpdateForm | formatTriggerCondition}}
					</el-descriptions-item>
					<el-descriptions-item label="报警" prop="openAlarm">
						<el-switch v-model="addOrUpdateForm.openAlarm" :disabled="true"></el-switch>
					</el-descriptions-item>
					<el-descriptions-item label="报警内容" prop="alarmMessage" v-if="addOrUpdateForm.openAlarm">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.alarmMessage"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="联动" prop="openLinkage">
						<el-switch v-model="addOrUpdateForm.openLinkage" :disabled="true" @change="openLinkageChange">
						</el-switch>
					</el-descriptions-item>
					<el-descriptions-item label="联动类型" prop="linkageType" v-if="addOrUpdateForm.openLinkage">
						{{addOrUpdateForm.linkageType | formatLinkageType}}
					</el-descriptions-item>
					<el-descriptions-item label="联动变量" prop="linkageVariableId" v-if="addOrUpdateForm.openLinkage">
						{{addOrUpdateForm.linkageDeviceTitle}}-{{addOrUpdateForm.linkageVariableTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="联动值类型"  prop="linkageWriteType" v-if="addOrUpdateForm.openLinkage&&addOrUpdateForm.linkageType=='write'">
						<el-radio-group size="mini" v-model="addOrUpdateForm.linkageWriteType" :disabled="true">
							<el-radio label="value">手写</el-radio>
							<el-radio label="trigger_value">触发值</el-radio>
						</el-radio-group>
					</el-descriptions-item>
					<el-descriptions-item label="联动值" prop="linkageWriteValue"
						v-if="addOrUpdateForm.openLinkage&&addOrUpdateForm.linkageType=='write'&&addOrUpdateForm.linkageWriteType=='value'">
						<el-input-number type="number" v-model="addOrUpdateForm.linkageWriteValue" :controls="false" :min="1" disabled :max="65536" :clearable="true"
							style="width: 300px;margin-top:-20px;display: block;" placeholder="请输入下发数据(十进制)"></el-input-number>
					</el-descriptions-item>
				</el-descriptions>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogDetailVisible=false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				label_style: {
					// 解决不对齐的问题
					'width': "100px", // 给标签设置足够的宽度之后让标签往右偏移
					'float': 'right',
					'text-align': 'right',
					'display': 'block',
					'word-break': 'break-all'
				},
				url: 'template/variable/trigger',
				name: '独立触发器',
				institutionList: [],
				dialogDetailVisible: false,
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				dialogDeviceVisible: false,
				deviceList: [],
				deviceLoading: false,
				queryLinkageDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				linkageDeviceLoading: false,
				linkageTemplateVariableList: [],
				linkageTemplateVariableLoading: false,
				linkageDeviceList: [],
				queryLinkageTemplateVariableParams: {
					currentPage: 1,
					pageSize: 3000,
					defaultSort: {}
				},
				queryTemplateVariableParams: {
					currentPage: 1,
					pageSize: 3000,
					defaultSort: {}
				},
				dialogTemplateVariableVisible: false,
				templateVariableList: [],
				templateVariableLoading: false,
				rules: {
					title: [{
							required: true,
							message: '请输入触发器名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度最长支持100',
							trigger: 'blur'
						}
					],
					type: [{
						required: true,
						message: '请选择触发器类型',
						trigger: 'change'
					}],
					institutionId: [{
						required: true,
						message: '请选择机构',
						trigger: 'blur'
					}],
					variableId: [{
						required: true,
						message: '请选择变量',
						trigger: 'blur'
					}],
					triggerCondition: [{
						required: true,
						message: '请选择触发条件',
						trigger: 'blur'
					}],
					linkageType: [{
						required: true,
						message: '请选择联动类型',
						trigger: 'change'
					}],
					linkageVariableId: [{
						required: true,
						message: '请选择联动变量',
						trigger: 'blur'
					}],
					linkageWriteValue: [{
						required: true,
						message: '请输入下发数据',
						trigger: 'blur'
					}],
				}
			};
		},
		filters: {
			formatTriggerCondition(data) {
				if (data) {
					var condition = data.triggerCondition
					if (data.triggerCondition) {
						if (condition.includes('A')) {
							condition = condition.replace('A', data.a)
						}
						if (condition.includes('B')) {
							condition = condition.replace('B', data.b)
						}
						return condition
					}
				}
			},
			formatType(type) {
				if (type == "device") {
					return '设备'
				}
			},
			formatLinkageType(type) {
				if (type == 'read') {
					return '采集'
				} else {
					return '控制'
				}
			},
			formatLinkage(data) {
				if (data.openLinkage) {
					var result = "";
					if (data.linkageType == 'read') {
						result += '采集：'
					} else {
						result += "控制："
					}
					result += data.linkageDeviceTitle + "-" + data.linkageVariableTitle
					return result;
				} else {
					return ""
				}
			},
		},
		methods: {
			beforeUpdate() {
				if (!this.addOrUpdateForm.openAlarm && !this.addOrUpdateForm.openLinkage) {
					this.errorMessage('系统提示', '报警、联动必须配置其中一个');
					return false;
				}
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {
						"openAlarm": false,
						openLinkage: false
					};
				}
			},
			handleDetail(row) {
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(row);
				this.dialogDetailVisible = true;
			},
			beforeEdit(isEdit) {
				if (!isEdit) {
					this.addOrUpdateForm.type = "device";
				}
				this.deviceList = [{
					id: this.addOrUpdateForm.deviceId,
					title: this.addOrUpdateForm.deviceTitle,
				}]
				this.templateVariableList = [{
					id: this.addOrUpdateForm.variableId,
					title: this.addOrUpdateForm.variableTitle,
				}]
				if (this.institutionId > 1) {
					this.addOrUpdateForm.institutionId = this.institutionId;
				}
				if (this.addOrUpdateForm.openLinkage) {
					this.linkageDeviceList = [{
						id: this.addOrUpdateForm.linkageDeviceId,
						title: this.addOrUpdateForm.linkageDeviceTitle,
					}]
					this.linkageTemplateVariableList = [{
						id: this.addOrUpdateForm.linkageVariableId,
						title: this.addOrUpdateForm.linkageVariableTitle,
					}]
				}
			},
			beforeValidate() {
				this.rules.variableId[0].message = "请选择变量"
			},
			deviceSelectFocus() {
				this.queryDeviceList()
			},
			institutionChange() {
				this.addOrUpdateForm.variableId = null
				this.addOrUpdateForm.deviceId = null
				this.addOrUpdateForm.templateId = null
				if (this.addOrUpdateForm.institutionId) {
					this.rules.variableId[0].message = "请选择变量"
					this.$refs['addOrUpdateForm'].clearValidate('variableId')
				}
			},
			deviceChange() {
				if (this.addOrUpdateForm.deviceId) {
					let device = this.deviceList.find((item) => item.id === this.addOrUpdateForm.deviceId);
					this.addOrUpdateForm.templateId = device.templateId
				} else {
					this.addOrUpdateForm.templateId = null
				}
				this.addOrUpdateForm.variableId = null

			},
			templateVariableChange() {
				this.$forceUpdate(); // 强制重新渲染当前组件
			},
			queryDeviceList(query) {
				if (!this.addOrUpdateForm.institutionId) {
					this.rules.variableId[0].message = "请先选择所属机构！"
					this.$refs['addOrUpdateForm'].validateField('variableId', valid => {

					})
					return;
				}
				let that = this;
				this.deviceLoading = true;
				this.queryDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryDeviceParams,
				}).then(function(res) {
					that.deviceList = res.data.data;
					that.deviceLoading = false
				})
			},
			templateVariableSelectFocus() {
				this.queryTemplateVariableList()
			},
			queryInstitutionList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'institution/query',
					data: {
						currentPage: 1,
						pageSize: 100
					},
				}).then(function(res) {
					that.institutionList = res.data.data;
				})
			},
			queryTemplateVariableList(query) {
				let that = this;
				this.queryTemplateVariableParams.title = query;
				if (this.addOrUpdateForm.templateId) {
					this.templateVariableLoading = true;
					this.queryTemplateVariableParams.templateId = this.addOrUpdateForm.templateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryTemplateVariableParams,
					}).then(function(res) {
						that.templateVariableList = res.data.data;
						that.templateVariableLoading = false
					})
				} else {
					that.templateVariableList = []
					this.addOrUpdateForm.variableId = null
				}
			},
			queryLinkageDeviceList(query) {
				if (!this.addOrUpdateForm.institutionId) {
					this.rules.variableId[0].message = "请先选择所属机构！"
					this.$refs['addOrUpdateForm'].validateField('linkageVariableId', valid => {

					})
					return;
				}
				let that = this;
				this.linkageDeviceLoading = true;
				this.queryLinkageDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryLinkageDeviceParams,
				}).then(function(res) {
					that.linkageDeviceList = res.data.data;
					that.linkageDeviceLoading = false
				})
			},
			linkageDeviceChange() {
				if (this.addOrUpdateForm.linkageDeviceId) {
					let device = this.linkageDeviceList.find((item) => item.id === this.addOrUpdateForm.linkageDeviceId);
					this.addOrUpdateForm.linkageTemplateId = device.templateId
				} else {
					this.addOrUpdateForm.linkageTemplateId = null
				}
				this.addOrUpdateForm.linkageVariableId = null
			},
			linkageDeviceSelectFocus() {
				this.queryLinkageDeviceList()
			},
			linkageTemplateVariableSelectFocus() {
				this.queryLinkageTemplateVariableList()
			},
			queryLinkageTemplateVariableList(query) {
				let that = this;
				this.queryLinkageTemplateVariableParams.title = query;
				console.log('linkageTemplateId', this.addOrUpdateForm.linkageTemplateId)
				if (this.addOrUpdateForm.linkageTemplateId) {
					this.linkageTemplateVariableLoading = true;
					this.queryLinkageTemplateVariableParams.templateId = this.addOrUpdateForm.linkageTemplateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryLinkageTemplateVariableParams,
					}).then(function(res) {
						that.linkageTemplateVariableList = res.data.data;
						that.linkageTemplateVariableLoading = false
					})
				} else {
					this.linkageTemplateVariableList = []
					this.addOrUpdateForm.linkageVariableId = null
				}
			},
			linkageTemplateVariableChange() {
				this.$forceUpdate(); // 强制重新渲染当前组件
			},
			openLinkageChange() {
				if (this.addOrUpdateForm.openLinkage) {
					this.addOrUpdateForm.linkageType = 'read';
				} else {
					this.addOrUpdateForm.linkageType = '';
					this.addOrUpdateForm.linkageWriteType = '';
					this.addOrUpdateForm.linkageWriteValue = '';
				}
			},
			linkageTypeChange() {
				if (this.addOrUpdateForm.linkageType == 'write') {
					this.addOrUpdateForm.linkageWriteType = 'value';
				} else {
					this.addOrUpdateForm.linkageWriteType = '';
				}
			}
		},
		mounted: function() {
			this.institutionId = sessionStorage.getItem('_institutionId');
			this.roleId = sessionStorage.getItem('_roleId');
			this.queryInstitutionList()
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/templateVariableTrigger.vue